import type { NoticeOfCommencement } from '@/types/jurisdiction';

export interface NocThresholdResult {
  amount: number;
  description?: string;
  matchedKey?: string;
}

function normalizePermitKey(value: string): string {
  const key = value.toLowerCase();
  if (key === 'hvac') return 'mechanical';
  return key;
}

export function getNocThreshold(
  noc: NoticeOfCommencement | null | undefined,
  permitTypes?: string | string[]
): NocThresholdResult | null {
  if (!noc) return null;

  const permitKeys = (Array.isArray(permitTypes) ? permitTypes : permitTypes ? [permitTypes] : [])
    .filter(Boolean)
    .map(normalizePermitKey);

  if (noc.thresholds) {
    for (const key of permitKeys) {
      const threshold = noc.thresholds[key];
      if (typeof threshold === 'number') {
        return {
          amount: threshold,
          description: noc.threshold_description,
          matchedKey: key,
        };
      }
    }

    if (typeof noc.thresholds.default === 'number') {
      return {
        amount: noc.thresholds.default,
        description: noc.threshold_description,
        matchedKey: 'default',
      };
    }
  }

  if (typeof noc.threshold === 'number') {
    return {
      amount: noc.threshold,
      description: noc.threshold_description,
    };
  }

  return null;
}
